import {
  BookOpenIcon,
  ClipboardCheckIcon,
  Clock3Icon,
  FileQuestionIcon,
  FlaskConicalIcon,
  GraduationCapIcon,
  LeafIcon,
  MicroscopeIcon,
  ScanSearchIcon,
  SmilePlusIcon,
  SproutIcon,
  TargetIcon,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface Stat {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '10', label: 'COMPLETE VOLUMES' },
  { value: '600+', label: 'PAGES OF CURRICULUM' },
  { value: '60', label: 'PAGES PER VOLUME' },
  { value: '100%', label: 'CURRICULUM ALIGNED' },
]

export const transformationStats: Stat[] = [
  { value: '600+', label: 'PAGES READY TO TEACH' },
  { value: '5', label: 'UNITS PER VOLUME' },
  { value: '100%', label: 'ANSWER KEYS INCLUDED' },
]

export const beforeItems: string[] = [
  'Hours every week searching for worksheets',
  'Piecing together lessons from random sites',
  'Unsure if the science is accurate or clear',
  'No labs, no assessments, no structure',
  'Feeling stretched thin and behind',
]

export const afterItems: string[] = [
  'A full year of biology ready to teach',
  'Clear theory with accurate labeled diagrams',
  'Activities, labs and assessments built in',
  'Answer keys and teacher tips for every unit',
  'Confident, organized, and ahead of the plan',
]

export interface PainPoint {
  icon: LucideIcon
  text: string
}

export const painPoints: PainPoint[] = [
  { icon: Clock3Icon, text: 'You’re overwhelmed building biology lessons from scratch.' },
  { icon: ScanSearchIcon, text: 'You’re never sure your diagrams and facts are correct.' },
  { icon: GraduationCapIcon, text: 'You spend weekends prepping instead of resting.' },
  { icon: SmilePlusIcon, text: 'Your students find biology boring or confusing.' },
  { icon: FlaskConicalIcon, text: 'You want labs and activities but have no time to design them.' },
  { icon: FileQuestionIcon, text: 'You need exam-ready material but can’t build it fast enough.' },
]

export interface KitItem {
  icon: LucideIcon
  title: string
  description: string
}

export const kitContents: KitItem[] = [
  { icon: BookOpenIcon, title: '10 Complete Volumes', description: 'Grades 1–12, ages 6–18' },
  { icon: LeafIcon, title: '600-Page Curriculum', description: 'Theory, diagrams, glossaries' },
  { icon: SproutIcon, title: 'Step-by-Step Practice', description: 'Activities & homework in every unit' },
  { icon: ClipboardCheckIcon, title: 'Assessments & Answer Keys', description: 'Exam-style questions, full solutions' },
  { icon: MicroscopeIcon, title: 'Hands-On Labs & Projects', description: 'Safe practicals with method + results' },
  { icon: TargetIcon, title: 'Curriculum Aligned', description: 'NGSS + UK National Curriculum + IB' },
]

export const instantAccessItems: string[] = [
  'All 10 complete volumes, Grades 1–12',
  'Theory, labeled diagrams and assessments in every grade',
  'Diagnostic and revision tools to place every student',
  'Ready-to-run guided and independent practice',
  'Print-ready and screen-ready — teach on paper or on a tablet',
  'Progress trackers and teacher tips for every unit',
]
